import {
  PATH_NAME_MEMBER_LOGIN,
  PATH_NAME_PROFILE_CHANGE,
  PATH_NAME_PROFILE_EDIT,
  PATH_NAME_PROFILE_LIST
} from '@/common/resources/router.const'

export default [
  {
    path: '/member/profile_list',
    name: PATH_NAME_PROFILE_LIST,
    alias: '/member/profile_list.html',
    components: {
      member: () => import(/* webpackChunkName: "profile_list" */'@/pages/member/profile_list')
    }
  },
  {
    path: '/member/profile_edit',
    name: PATH_NAME_PROFILE_EDIT,
    alias: '/member/profile_edit.html',
    components: {
      member: () => import(/* webpackChunkName: "profile_edit" */'@/pages/member/profile_edit')
    }
  },
  {
    path: '/member/profile_change',
    name: PATH_NAME_PROFILE_CHANGE,
    alias: '/member/profile_change.html',
    components: {
      member: () => import(/* webpackChunkName: "profile_change" */'@/pages/member/profile_change')
    }
  },
  {
    path: '/member/member_login.html',
    name: PATH_NAME_MEMBER_LOGIN,
    components: {
      member: () => import(/* webpackChunkName: "member_login" */'@/pages/member/member_login')
    }
  }
]
